import logger from 'app/utils/debug/logger';
import EventEmitter from 'events';
import ModbusXRayGeneratorController from 'app/adapters/XRayGenerator/ModbusXRayGeneratorController';
import XRayGeneratorController from 'app/adapters/XRayGenerator/XRayGeneratorController';
import modbusSerial from 'app/native/modules/modbus-serial';
import SequentialModbusRTU from 'app/adapters/SequentialModbusRTU';

export default class SerialXRayGeneratorControllerHandle extends EventEmitter {
  constructor(serialportModule, devicePath) {
    super();

    /** @type {import('serialport')} */
    this.serialportModule = serialportModule;
    this.devicePath = devicePath;
    this.id = devicePath;
  }

  connectDirectCommunicationMode() {
    return new Promise((resolve, reject) => {
      const modbusRTU = new (modbusSerial())();
      modbusRTU.connectRTUBuffered(
        this.devicePath,
        {
          baudRate: 9600,
          dataBits: 8,
          parity: 'none',
          stopBits: 1,
          autoOpen: false,
        },
        (error) => {
          if (error) {
            reject(error);
            return;
          }
          console.debug('ModbusRTUBuffered connected', modbusRTU);
          // eslint-disable-next-line no-underscore-dangle
          const serialPort = modbusRTU._port._client;
          serialPort.on('close', () => {
            // Not protected by tests, hard to do but needed
            this.emit('disconnected');
          });

          serialPort.on('error', (event) => {
            if (event.message === 'Port is not open') return;
            logger.warn('SerialPort error', event);
          });

          console.debug('ModbusRTUBuffered connected', modbusRTU);

          console.debug('Serial port open, connected', serialPort.settings);

          resolve(new ModbusXRayGeneratorController(new SequentialModbusRTU(modbusRTU)));
        }
      );
    });
  }

  connectProtocolBoardCommunicationMode() {
    return new Promise((resolve, reject) => {
      const serialPort = new this.serialportModule.SerialPort(
        {
          path: this.devicePath,
          baudRate: 19200,
          dataBits: 8,
          parity: 'none',
          stopBits: 2,
          rts: true,
          rtsMode: 'enable',
        },
        (error) => {
          if (error) {
            reject(error);
            return;
          }

          serialPort.on('close', () => {
            // Not protected by tests, hard to do but needed
            this.emit('disconnected');
          });

          serialPort.on('error', (event) => {
            if (event.message === 'Port is not open') return;
            logger.warn('SerialPort error', event);
          });

          resolve(new XRayGeneratorController(serialPort));
        }
      );
    });
  }

  connect(isDirectCommunicationMode = false) {
    if (isDirectCommunicationMode) {
      return this.connectDirectCommunicationMode();
    }
    return this.connectProtocolBoardCommunicationMode();
  }
}
